export default "__VITE_ASSET__dd733357__"